import { Box, Heading, Divider } from '@chakra-ui/react'
import Fundamentals from './Fundamentals'
import KeyComponents from './KeyComponents'
import ImplementationSteps from './ImplementationSteps'
import Mistakes from './Mistakes'
import FinalTips from './FinalTips'
import QuickStart from './QuickStart'

const TPIGuide = () => (
  <Box p={5} shadow="md" borderWidth="1px" borderRadius="lg">
    <Heading as="h2" size="xl" mb={4} color="brand.primary">
      Comprehensive Strategy Implementation Guide
    </Heading>
    <Heading as="h3" size="lg" mb={3} color="brand.secondary">
      In-Depth Bitcoin Sentiment Trading Strategy Guide
    </Heading>
    <Fundamentals />
    <KeyComponents />
    <Divider my={6} />
    <ImplementationSteps />
    <Divider my={6} />
    <Mistakes />
    <Divider my={6} />
    <FinalTips />
    <Divider my={6} />
    <QuickStart />
  </Box>
)

export default TPIGuide
